import * as React from 'react';
import * as PropTypes from 'prop-types';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reduxForm, Form, Field, formPropTypes } from 'redux-form/immutable';

import renderDateField from '../../../components/DateField/reduxFormDateField';
import renderSelect from '../../../components/Select/reduxForm';
import renderField from '../../../components/Textarea/reduxForm';
import { NumberField } from '../../../components/Field/NumberField';
import * as selectors from '../selectors';
import Button from '../../../components/Button';

export class EditCheckForm extends React.Component {
  static propTypes = {
    form: PropTypes.shape(formPropTypes).isRequired,
    submit: PropTypes.func,
    onCancel: PropTypes.func,
    dictionaryCategories: PropTypes.object,
  };

  handleOkClick = (e) => {
    e.preventDefault();

    this.props.submit();
  };

  handleCancelClick = (e) => {
    e.preventDefault();

    const { onCancel } = this.props;

    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  render() {
    const { form, dictionaryCategories } = this.props;

    return (
      <Form onSubmit={form.handleSubmit}>
        <Field
          name={'originDate'}
          component={renderDateField}
          label={'Дата и время'}
          isDisabled={true}
          showDateTime
        />

        <Field name={'originSum'} component={NumberField} label={'Сумма'} isDisabled={true} />

        <Field
          name={'description'}
          label={'Описание'}
          component={renderField}
          normalize={(value) => value && value.replace(/;/g, '')}
          tooltipContent={
            'Укажите любую полезную информацию по чеку: название организации, объект и цель приобретения, потребителя услуги или период. Например: EnglishSchool, курсы английского, сын Ваня, апрель 2019'
          }
        />

        <Field
          name={'receiptCategory'}
          label={'Категория'}
          component={renderSelect}
          // parse={property('value')}
          options={dictionaryCategories}
          tooltipTitle={null}
          tooltipContent={
            'Укажите категорию для удобства фильтрации и подбора чеков при оформлении вычетов в 3-НДФЛ. Если ни одна из категорий не подошла, выберите «Прочее»'
          }
          isFull
        />

        <div className={'steps_button'}>
          <Button type={'button'} color={'blue'} hasWrapper={true} onClick={this.handleCancelClick}>
            {'Отменить'}
          </Button>

          <Button type={'button'} color={'orange'} hasWrapper={true} onClick={this.handleOkClick}>
            {'Сохранить'}
          </Button>
        </div>
      </Form>
    );
  }
}

export default compose(
  reduxForm({
    form: 'addCheck',
    propNamespace: 'form',
    destroyOnUnmount: true,
    onSubmit: (iValues, dispatch, { onOk }) => {
      const values = iValues.toJS();

      if (typeof onOk === 'function') {
        onOk(values);
      }
    },
  }),
  connect(
    createStructuredSelector({
      dictionaryCategories: selectors.getDictionaryCategories,
    }),
  ),
)(EditCheckForm);
